import { iconPaths, iconViewBoxes } from './icons';

export default function Icon({ 
  name, 
  className = "", 
  size,
  ...props 
}) {
  const path = iconPaths[name];
  const viewBox = iconViewBoxes[name] || "0 0 24 24";

  if (!path) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  // Default size classes if size prop is provided
  const sizeClasses = size ? `w-${size} h-${size}` : 'w-6 h-6';

  return (
    <svg
      viewBox={viewBox}
      fill="currentColor"
      className={`${sizeClasses} ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d={path} />
    </svg>
  );
}